import { useEffect, useRef } from 'react';

import { useLocale } from '../../hooks/useLocale';
import { TTheme } from '../../types';

type TProps = {
  theme?: TTheme;
};

const TrustPilot = ({ theme = 'light' }: TProps) => {
  const { isDE } = useLocale();
  const ref = useRef(null);

  useEffect(() => {
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((window as any).Trustpilot) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).Trustpilot.loadFromElement(ref.current, true);
    }
  }, [theme]);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale={isDE ? 'de-DE' : 'en-US'}
      data-template-id={
        isDE ? '5419b6ffb0d04a076446a9af' : '5419b6ffb0d04a076446a9af'
      }
      data-businessunit-id={
        isDE ? '54c8fb060000ff00057d0a8a' : '5098036f00006400051e2962'
      }
      data-style-height="40px"
      data-style-width="100%"
      data-theme={theme}
    >
      <a
        href={
          isDE
            ? 'https://de.trustpilot.com/review/www.iwoca.de'
            : 'https://www.trustpilot.com/review/iwoca.co.uk'
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustPilot;
